import type { RouteRecordRaw } from "vue-router";
import { APP_SETTINGS_INVOICES_ROUTES as INVOICES } from "@/Generated/Routes/paths";

const invoices: RouteRecordRaw[] = [
  {
    ...INVOICES.root,
    meta: {
      noHeader: true,
    },
    component: () => import("@/Views/settings/invoices/index.vue"),
  },
  {
    ...INVOICES.detail.root,
    meta: {
      noHeader: true,
    },
    component: () => import("@/Views/settings/invoices/MonthDetail.vue"),
  },
];

export default invoices;
